import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./shopifyRickyOrder.module.css";
import { BounceLoader } from "react-spinners";
import { getBatchShopifyRickyOrder } from "../../../redux/actions/apiActions";
import ShopifyRickyOrders from "./vtexOrders/shopifyRickyOrders";
import Pagination from "../../../components/Paginate/paginate";

function ShopifyRickyOrder() {
  const dispatch = useDispatch();

  const { batchShopifyOrderSarkanyUs, loading, paginate } = useSelector((state) => state.apiData);

  useEffect(() => {
    dispatch(getBatchShopifyRickyOrder(1));
  }, [dispatch]);
      const handlePageChange = (page) => {
      dispatch(getBatchShopifyRickyOrder(page)); 
    };
  return (
    <div className={loading ? style.OrderVtexApiContainerLoading : style.vtexOrderApiContainer}>
      {loading ? (
        <BounceLoader className={style.spinner} color="#61a030" />
      ) : (
        <>
          <div className={style.OrderApiEncabezado}>
            <ul className={`${style.uLlist} nav row`}>
              {["Fecha órdenes","Total Elementos", "Fecha de Inicio", "Fecha de fin", "Duración", "Estado", "Llamar ahora","Descargar CSV"].map((text, idx) => (
                <li key={idx} className="nav-item col">
                  <span className="nav-link">{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
             {batchShopifyOrderSarkanyUs?.map((batch, idx) => (
              <ShopifyRickyOrders key={batch._id || idx} item={batch} />
            ))} 
          </div>
        </>
      )}
          <div>
        <Pagination paginate={paginate} isLoading={loading} onPageChange={handlePageChange} />
      </div>
    </div>
  );
}

export default ShopifyRickyOrder;
